exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  margin: 0px;\n  font-size: 1.8rem;\n}\n\n#funds {\n  -webkit-column-count: 2;\n          column-count: 2;\n  -webkit-column-gap: 10em;\n          column-gap: 10em;\n  -webkit-column-rule: 1px solid #ddd;\n          column-rule: 1px solid #ddd;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/src/app/funds/print.component.css
// module id = ../../../../../src/app/funds/print.component.css
// module chunks = main